<!-- TABS -->
<div class="grid-row tabs dashboard-tabs mt-3 mb-4">
	<ul class="ps-0 mb-0">
		<!-- CONFIRMING -->
		@if (confirmingTabVisible) {
			<li
				[ngClass]="{
					'': !confirmingTabSelected,
					'is-active': confirmingTabSelected,
				}">
				<a (click)="clickedConfirmingTab()">
					{{ 'menu.Confirming' | translate }}
				</a>
			</li>
		}
		<!-- FACTORING -->
		@if (factoringTabVisible) {
			<li
				[ngClass]="{
					'': !factoringTabSelected,
					'is-active': factoringTabSelected,
				}">
				<a (click)="clickedFactoringTab()">
					{{ 'menu.Factoring' | translate }}
				</a>
			</li>
		}
	</ul>

	<!-- REFRESH BUTTON -->
	<eif-custom-button
		[text]="'button.refresh' | translate"
		[preIcon]="'fa-solid fa-sync-alt'"
		(action)="refreshAllData()">
	</eif-custom-button>
</div>

<!-- CONFIRMING AREA -->
@if (loggedUser?.canSeeConfirmingOptions()) {
	@if (confirmingTabSelected) {
		<div class="grid-row">
			<!-- CURRENCIES -->
			@if (orderedCurrencies.length > 1) {
				<ul class="currency-wrap mt-0 mb-4">
					@for (orderedCurrency of orderedCurrencies; track orderedCurrency.Currency; let i = $index) {
						<li>
							<eif-custom-button
								[text]="orderedCurrency.Currency"
								[variant]="orderedCurrency.Selected ? 'standard' : 'outlined'"
								[color]="orderedCurrency.Selected ? 'primary' : 'neutral'"
								(action)="clickedCurrency(orderedCurrency.Currency)">
							</eif-custom-button>
						</li>
					}
				</ul>
			}
			<div class="dashboard-cards-wrap">
				<eif-dashboard-card
					value="{{ confirmingApprovedRequestFunds | currencyLocale: selectedCurrency }}"
					description="{{ 'dashboard-supplier.approvedRequestFunds' | translate }} ({{ CurrentMonth }})"
					[icon]="'fa-light fa-hand-holding-usd'"
					[loading]="loadingConfirmingApprovedRequestFunds"
					[color]="'1'" />
				<eif-dashboard-card
					value="{{ currentFundingRequestsAmount | currencyLocale: selectedCurrency }}"
					description="{{ 'dashboard-supplier.currentFundingRequestsAmount' | translate }}"
					[icon]="'fa-light fa-hand-holding-usd'"
					[loading]="loadingCurrentFundingRequestsAmount"
					[color]="'2'" />
				<eif-dashboard-card
					value="{{ notPaidDocuments | currencyLocale: selectedCurrency }}"
					description="{{ 'dashboard-supplier.notPaidDocuments' | translate }}"
					[icon]="'fa-light fa-file-invoice'"
					[loading]="loadingNotPaidDocuments"
					[color]="'3'" />
				<eif-dashboard-card
					value="{{ suppliersActiveConnections }}"
					description="{{ 'dashboard-supplier.suppliersActiveConnections' | translate }}"
					[icon]="'fa-light fa-chart-network'"
					[loading]="loadingSuppliersActiveConnections"
					[color]="'8'" />
			</div>
		</div>
	}
}

<!-- FACTORING AREA -->
@if (loggedUser?.canSeeFactoringOptions()) {
	@if (factoringTabVisible) {
		<div class="grid-row">
			@if (factoringTabSelected) {
				<div class="dashboard-cards-wrap">
					<eif-dashboard-card
						value="{{ factoringPortfolioAmount | currencyLocale: selectedCurrency }}"
						description="{{ 'dashboard-supplier.factoringPortfolioAmount' | translate }}"
						[icon]="'fa-light fa-hands-usd'"
						[loading]="loadingFactoringPortfolioAmount"
						[color]="'1'" />
					<eif-dashboard-card
						value="{{ factoringAdvancedAmount | currencyLocale: selectedCurrency }}"
						description="{{ 'dashboard-supplier.factoringAdvancedAmount' | translate }}"
						[icon]="'fa-light fa-money-check-alt'"
						[loading]="loadingFactoringAdvancedAmount"
						[color]="'2'" />
					<eif-dashboard-card
						value="{{ factoringAdvanceableAmount | currencyLocale: selectedCurrency }}"
						description="{{ 'dashboard-supplier.factoringAdvanceableAmount' | translate }}"
						[icon]="'fa-light fa-money-check-alt'"
						[loading]="loadingFactoringAdvanceableAmount"
						[color]="'3'" />
					<eif-dashboard-card
						value="{{ factoringBuyersActiveConnections }}"
						description="{{ 'dashboard-supplier.factoringBuyersActiveConnections' | translate }}"
						[icon]="'fa-light fa-chart-network'"
						[loading]="loadingFactoringBuyersActiveConnections"
						[color]="'8'" />
					<eif-dashboard-card
						value="{{ factoringPendingApprovalDocumentsAmount }}"
						description="{{ 'dashboard-supplier.factoringPendingApprovalDocumentsAmount' | translate }}"
						[icon]="'fa-regular fa-hourglass-clock'"
						[loading]="loadingFactoringPendingApprovalDocumentsAmount"
						[color]="'7'"
						[hasAction]="true"
						(action)="navigateToFilesIntegration(FileStatus.PendingSupplierApproval)" />
				</div>
			}
		</div>
	}
}

<!-- Charts area -->
@if (confirmingTabSelected) {
	<div class="dashboard-chart-wrapper mt-4">
		<div class="is-label">
			{{ 'dashboard-supplier.documentForecast' | translate }}
		</div>
		<div
			id="chart-1"
			class="dashboard-chart">
			<ngx-charts-bar-vertical-stacked
				[scheme]="documentForecastChart.ColorScheme"
				[results]="documentForecastChart.Results"
				[xAxis]="documentForecastChart.ShowXAxis"
				[yAxis]="documentForecastChart.ShowYAxis"
				[showXAxisLabel]="documentForecastChart.ShowXAxisLabel"
				[xAxisLabel]="documentForecastChart.XAxisLabel"
				[yAxisLabel]="documentForecastChart.YAxisLabel"
				[showYAxisLabel]="documentForecastChart.ShowYAxisLabel"
				[legend]="documentForecastChart.ShowLegend"
				[legendTitle]="documentForecastChart.LegendTitle"
				[noBarWhenZero]="true">
				<ng-template
					#tooltipTemplate
					let-model="model">
					<!-- fields are series/name/value -->
					<div class="tt">
						<div>{{ model.series }} &#8226; {{ model.name }}</div>
						{{ model.value | currencyLocale: selectedCurrency }}
					</div>
				</ng-template>
			</ngx-charts-bar-vertical-stacked>
		</div>
	</div>
}
